import * as React from "react";
import * as _ from "lodash";
import {
  Button,
  Dropdown,
  Icon,
  Modal,
  Segment,
  Select,
  Table,
} from "semantic-ui-react";
import { Base, Event, IBaseProps, IBaseState, IResource } from "./Base";
import { toast } from "react-semantic-toasts";

export interface IInviteMemberModelProps extends IBaseProps {
  resource: IResource;
  open: boolean;
  setModal: (open: boolean) => void;
  userAdded: () => void;
}

export interface IInviteMemberModelState extends IBaseState {
  selectedUser: any;
  members: any[];
  resourceMembers: any[];
  deleting: boolean;
}

class InviteMemberModel extends Base<
  IInviteMemberModelProps,
  IInviteMemberModelState
> {
  private static PERMISSION_OPTIONS = [
    {
      key: "member",
      text: "member",
      value: "member",
      content: "Member",
    },
    {
      key: "admin",
      text: "admin",
      value: "admin",
      content: "Admin",
    },
    {
      key: "owner",
      text: "owner",
      value: "owner",
      content: "Owner",
    },
  ];

  constructor(props: IInviteMemberModelProps) {
    super(props);
    this.state = {
      ...Base.BASE_INITAL_STATE,
      selectedUser: null,
      members: [],
      resourceMembers: [],
      deleting: false,
    };
  }
  public componentDidMount = () => {
    this.getData();
  };

  public componentDidUpdate = (prevProps, prevState) => {
    if (this.props.open !== prevProps.open && this.props.open) {
      this.getData();
    }
  };

  public render() {
    const { selectedUser, members, resourceMembers, deleting } = this.state;
    const { resource, open, setModal, authUser } = this.props;
    const loading = _.isEmpty(resourceMembers);
    return (
      <Modal
        onClose={() => setModal(false)}
        onOpen={() => setModal(true)}
        open={open}
      >
        <Modal.Header>Add users to {resource.name}</Modal.Header>
        <Modal.Content>
          {loading && <Segment loading={true} style={{ minHeight: "200px" }} />}
          {!loading && (
            <div>
              <Select
                name={"searchuser"}
                placeholder="Search Users"
                noResultsMessage="All users part of this organization are added."
                fluid={true}
                search={true}
                selection={true}
                value={selectedUser ? selectedUser.value : ""}
                onChange={this.handleSearchUsersDDChange}
                options={_.map(members, (m, index) => ({
                  key: m.id + index,
                  text: m.name + " - " + m.email,
                  value: m.id,
                }))}
              />
              <Button size="tiny" onClick={this.handleAddUserButtonClick}>
                Add
              </Button>
              <div>
                <Table
                  sortable={true}
                  celled={true}
                  fixed={true}
                  striped={true}
                  compact="very"
                  className="invite-members-model-table"
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Name</Table.HeaderCell>
                      <Table.HeaderCell>Permission</Table.HeaderCell>
                      <Table.HeaderCell>&nbsp;</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {_.map(
                      resourceMembers,
                      ({ uid, name, email, admin, owner }) => (
                        <Table.Row key={name}>
                          <Table.Cell>
                            {name} -{" "}
                            <span
                              style={{ color: "#b1acac", fontStyle: "italic" }}
                            >
                              {email}
                            </span>
                          </Table.Cell>
                          <Table.Cell>
                            {uid !== authUser.uid && (
                              <Dropdown
                                inline={true}
                                options={InviteMemberModel.PERMISSION_OPTIONS}
                                onChange={(e, { value }) =>
                                  this.handleOnPermissionChange(uid, value)
                                }
                                value={
                                  owner ? "owner" : admin ? "admin" : "member"
                                }
                              />
                            )}
                            {uid === authUser.uid &&
                              (owner ? "owner" : admin ? "admin" : "member")}
                          </Table.Cell>
                          <Table.Cell>
                            {uid !== authUser.uid && (
                              <React.Fragment>
                                {!deleting && (
                                  <Icon
                                    link={true}
                                    name="trash alternate outline"
                                    onClick={() => this.handleDeleteMember(uid)}
                                  />
                                )}
                                {deleting && (
                                  <Icon loading={true} name="spinner" />
                                )}
                              </React.Fragment>
                            )}
                          </Table.Cell>
                        </Table.Row>
                      )
                    )}
                  </Table.Body>
                </Table>
              </div>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setModal(false)}>Close</Button>
        </Modal.Actions>
      </Modal>
    );
  }

  protected getData = () => {
    const { orgId, authUser, resource } = this.props;

    resource.api
      .requestListMembers(orgId, authUser.uid, resource.id)
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          resource.api.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp) {
              const resourceMembers = resp.members;
              const resourceMemberIds = resourceMembers.map((rm) => rm.uid);
              this.getMembers((data) => {
                const members = _.filter(data, (u) => {
                  return (
                    u.id !== authUser.uid &&
                    resourceMemberIds.indexOf(u.id) === -1
                  );
                });
                this.setState({ members, resourceMembers, selectedUser: null });
              });
            }
          }
        );
      });
  };

  private handleSearchUsersDDChange = (
    event: React.SyntheticEvent,
    data: any
  ) => {
    this.setState({ selectedUser: data });
  };

  private handleDeleteMember = (memberId: string) => {
    const { orgId, authUser, resource } = this.props;
    this.setState({ deleting: true });
    resource.api
      .deleteUserToResource(orgId, authUser.uid, resource.id, memberId)
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          resource.api.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp && resp.headers) {
              if (resp.headers.statusCode === 200) {
                this.getData();
                this.props.userAdded();
                this.setState({ deleting: false });
                toast({
                  type: "success",
                  icon: "info circle",
                  title: `User successfully removed`,
                  animation: "slide up",
                  time: 5000,
                });
              } else {
                this.setState({ deleting: false });
                toast({
                  type: "error",
                  icon: "info circle",
                  title: `failed to remove user  `,
                  animation: "slide up",
                  time: 5000,
                });
              }
            }
          }
        );
      });
  };

  private handleOnPermissionChange = (memberId: string, value: any) => {
    const { orgId, authUser, resource } = this.props;
    resource.api
      .changePermissionToResource(
        orgId,
        authUser.uid,
        resource.id,
        memberId,
        value
      )
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          resource.api.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp && resp.headers) {
              if (resp.headers.statusCode === 200) {
                this.getData();
                toast({
                  type: "success",
                  icon: "info circle",
                  title: `User permission successfully changed`,
                  animation: "slide up",
                  time: 5000,
                });
              } else {
                toast({
                  type: "error",
                  icon: "info circle",
                  title: `failed to change user permission`,
                  animation: "slide up",
                  time: 5000,
                });
              }
            }
          }
        );
      });
  };

  private handleAddUserButtonClick = () => {
    const { selectedUser } = this.state;
    const { orgId, authUser, resource } = this.props;
    resource.api
      .addUserToResource(orgId, authUser.uid, resource.id, selectedUser.value)
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          resource.api.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp && resp.headers) {
              if (resp.headers.statusCode === 200) {
                this.getData();
                this.props.userAdded();
                toast({
                  type: "success",
                  icon: "info circle",
                  title: `User added successfully `,
                  animation: "slide up",
                  time: 5000,
                });
              } else {
                toast({
                  type: "error",
                  icon: "info circle",
                  title: `failed to add user  `,
                  animation: "slide up",
                  time: 5000,
                });
              }
            }
          }
        );
      });
  };
}

export default InviteMemberModel;



// WEBPACK FOOTER //
// ./src/components/Common/InviteMemberModal.tsx